import React, { useEffect } from 'react';
import { Glyphicon } from 'react-bootstrap';
import { clearUser } from '../../utils/FRLogout';
import { LOGOUT_MULTI_TAB_KEY } from '../../constants/SessionTimer';

const NavUserInfo = (props) => {
    const handleLogout = () => {
        props.toast('success', 'Logged out successfully');
        localStorage.setItem(LOGOUT_MULTI_TAB_KEY, String(Date.now()));
        clearUser();
    }
    useEffect(() => {
    
        // storage listener (for multi-tab)
        const handleMultiTab = (event) => {
          const { key, newValue } = event;
          if (!key) return;
    
          if (key === LOGOUT_MULTI_TAB_KEY && newValue) {
            console.log('Received logout broadcast from another tab');
            clearUser();
          }
    
          
        };
    
        window.addEventListener('storage', handleMultiTab);
    
        return () => {
          window.removeEventListener('storage', handleMultiTab);
        };
      }, []);
    return (
        <div className="nav-userinfo">
            <p>
                {
                    props.currentUser &&
                    <Glyphicon glyph="user" style={{ marginRight: '0.5em' }} />
                }
                <b>{props.currentUser ? props.currentUser.fullName : ''}</b>
                <Glyphicon glyph="log-out" onClick={() => handleLogout(props)}
                    style={{ cursor: 'pointer', marginLeft: '1em' }} />
            </p>
        </div>
    );
}

export default NavUserInfo;